import React from 'react';
import { View } from 'react-native';
import Svg, { Path, G, Defs, Filter, FeFlood, FeBlend, FeGaussianBlur } from 'react-native-svg';

interface AvatarBlurRingProps {
  children: React.ReactNode;
  size?: number;
}

export default function AvatarBlurRing({ children, size = 32 }: AvatarBlurRingProps) {
  const padding = 2;
  const containerSize = size + padding * 2;
  const scale = containerSize / 36;

  return (
    <View
      style={{
        width: containerSize,
        height: containerSize,
        borderRadius: containerSize / 2,
        backgroundColor: '#669AB7',
        padding,
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <View
        style={{
          position: 'absolute',
          width: 73.085 * scale,
          height: 70.975 * scale,
          top: -17 * scale,
          left: -19 * scale,
        }}
      >
        <Svg
          width={73.085 * scale}
          height={70.975 * scale}
          viewBox="0 0 74 71"
          fill="none"
        >
          <Defs>
            <Filter
              id="f0"
              x="-7.49246"
              y="-5.76931"
              width="56.4752"
              height="54.7515"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <FeFlood floodOpacity="0" result="BackgroundImageFix" />
              <FeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <FeGaussianBlur stdDeviation="5.0431" result="effect1" />
            </Filter>
            <Filter
              id="f1"
              x="-2.23269"
              y="25.2678"
              width="55.2623"
              height="53.4571"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <FeFlood floodOpacity="0" result="BackgroundImageFix" />
              <FeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <FeGaussianBlur stdDeviation="5.0431" result="effect1" />
            </Filter>
            <Filter
              id="f2"
              x="36.1207"
              y="8.48838"
              width="45.4852"
              height="57.0272"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <FeFlood floodOpacity="0" result="BackgroundImageFix" />
              <FeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <FeGaussianBlur stdDeviation="4.25996" result="effect1" />
            </Filter>
          </Defs>
          <G opacity="0.9" filter="url(#f0)">
            <Path
              d="M6.12888 35.1141C-0.0181587 28.9671 2.17845 26.8069 10.1825 18.8029C18.1865 10.7989 28.9669 -0.0179672 35.1139 6.12907C41.261 12.2761 39.7556 23.7478 31.7516 31.7518C23.7476 39.7558 12.2759 41.2612 6.12888 35.1141Z"
              fill="white"
            />
          </G>
          <G filter="url(#f1)">
            <Path
              d="M40.6719 62.2497C35.8241 71.0011 33.4567 69.6558 24.7052 64.808C15.9538 59.9603 4.13247 53.4459 8.98021 44.6945C13.8279 35.9431 24.8522 32.7785 33.6036 37.6262C42.355 42.474 45.5196 53.4983 40.6719 62.2497Z"
              fill="#015480"
            />
          </G>
          <G filter="url(#f2)">
            <Path
              d="M72.7374 37.0019C72.7374 48.044 75.6498 56.9955 64.6171 56.9955C53.5844 56.9955 44.6406 48.044 44.6406 37.0019C44.6406 25.9597 53.5844 17.0083 64.6171 17.0083C75.6498 17.0083 72.7374 25.9597 72.7374 37.0019Z"
              fill="#015480"
            />
          </G>
        </Svg>
      </View>
      <View style={{ zIndex: 1 }}>{children}</View>
    </View>
  );
}
